module.exports = __webpack_public_path__ + "static/jergal_prince_of_lies-65f38c6089f211b7a387913835f60906.webp";